/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.production = process.env.PRODUCTION || "true",
config.sitecoreApiHost = process.env.SITECORE_API_HOST || "https://www.piraeusbank.gr",
config.sitecoreApiKey = process.env.SITECORE_API_KEY || "{4733E970-AC51-4B90-9497-28E15571D37B}",
config.jssAppName = process.env.JSS_APP_NAME || "piraeusbank",
config.sitecoreLayoutServiceConfig = process.env.SITECORE_LAYOUT_SERVICE_CONFIG || "sxa-jss",
config.defaultLanguage = process.env.DEFAULT_LANGUAGE || "en",
config.defaultServerRoute = process.env.DEFAULT_SERVER_ROUTE || "/",
config.layoutServiceConfigurationName = process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || "sxa-jss",
config.urlOrigin = process.env.URL_ORIGIN || "https://www.piraeusbank.gr",
config.assetsUrl = process.env.ASSETS_URL || "/dist/piraeusbank/browser/assets/",
config.searchApiHost = process.env.SEARCH_API_HOST || "https://discover-euc1.sitecorecloud.io/discover/v2/",
config.searchPublishEventApiHost = process.env.SEARCH_PUBLISH_EVENT_API_HOST || "https://discover-euc1.sitecorecloud.io/event/11180407-233505176/v4/publish",
config.searchDomainId = process.env.SEARCH_DOMAIN_ID || "233505176",
config.searchApiKey = process.env.SEARCH_API_KEY || "01-62db6f03-421358e57497fe599436b847c05968e6cfefeff1",
config.searchApiSource = process.env.SEARCH_API_SOURCE || "1078133",
config.searchViewEventsEnabled = process.env.SEARCH_VIEW_EVENTS_ENABLED || "true",
config.recaptchaSiteKey = process.env.RECAPTCHA_SITE_KEY || "6LdQnnwqAAAAAFoSRKgFwg4hngqZM6JVQMOMLvTC",
config.cookieDomain = process.env.COOKIE_DOMAIN || "62e4f123-c06e-4a56-885d-5ea16396637e",
config.notFound404 = process.env.NOT_FOUND404 || "support%2f404-page",
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || "/sitecore/api/graph/edge",
config.userWayEnabled = process.env.USER_WAY_ENABLED || "true",
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || `${config.sitecoreApiHost}${config.graphQLEndpointPath}`;
module.exports.environment = config;